<template>
  <div class="project-user-list page-box">
    <query-header
      ref="header"
      :selected="selected"
      @add="addHandle"
      @delete="deleteHandle"
      @toQuery="toQuery"
      @strategy-options="setStrategyOptions"
    ></query-header>
    <div class="page-content">
      <div class="vs-table-outer">
        <vs-table
          multiple
          v-model="selected"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              规则名称
            </vs-th>
            <vs-th>
              策略名称
            </vs-th>
            <vs-th>
              策略渠道
            </vs-th>
            <vs-th>
              策略来源
            </vs-th>
            <vs-th>
              策略作者
            </vs-th>
            <vs-th>
              推送渠道
            </vs-th>
            <vs-th>
              推送配置
            </vs-th>
            <vs-th>
              渠道编号
            </vs-th>
            <vs-th>
              推送签名
            </vs-th>
            <vs-th>
              失效日期
            </vs-th>
            <vs-th>
              状态
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td
                style="max-width: 120px"
              >
                {{tr.ruleName || '-'}}
              </vs-td>
<!--              <vs-td>
                {{tr.strategySour || '-'}}
              </vs-td>-->
              <vs-td
                style="max-width: 120px"
              >
                {{tr.strategyName}}
              </vs-td>
              <vs-td>
                {{getSource(tr)}}
              </vs-td>
              <vs-td>
                {{getStrategySourceName(tr)}}
              </vs-td>
              <vs-td>
                {{getStrategyAuthorName(tr)}}
              </vs-td>
              <vs-td>
                {{getChannel(tr)}}
              </vs-td>
              <vs-td>
                {{tr.senderName || tr.senderId || '-'}}
              </vs-td>
              <vs-td
                style="max-width: 200px;"
              >
                {{tr.receiverName || tr.receiverId}}
              </vs-td>
              <vs-td
                style="max-width: 120px"
              >
                {{tr.titlePrefix}}
              </vs-td>
              <vs-td
                style="max-width: 80px"
              >
                {{tr.expireDate}}
              </vs-td>
              <vs-td>
                <span
                  class="self-tag"
                  :style="getType(tr)"
                >{{tr.status ? '启用': '禁用' }}</span>
              </vs-td>
              <vs-td>

                <el-button
                  type="text"
                  v-if="isAuth('wx:spiderArticlePublish:update')"
                  class=""
                  @click.stop="editHandle(tr)"
                >修改</el-button>
                <el-button
                  v-if="isAuth('wx:spiderArticlePublish:delete')"
                  type="text"
                  class="delete-btn"
                  @click="deleteHandle(tr.id)"
                >删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <add-push-rule-dialog
      :dialog-show="addDialogShow"
      @close="closeAddDialog"
      @add-success="addUserSuccess"
    ></add-push-rule-dialog>
    <edit-push-rule-dialog
      :form-data="currentRow"
      :dialog-show="editDialogShow"
      @close="closeEditDialog"
      @edit-success="editUserSuccess"
    ></edit-push-rule-dialog>
    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
  </div>
</template>

<script>
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import editPushRuleDialog from '@/components/sys/messagePushRule/editPushRuleDialog'
import addPushRuleDialog from "@/components/sys/messagePushRule/addPushRuleDialog";
import queryHeader from "@/components/sys/messagePushRule/queryHeader";
import { mapGetters } from 'vuex'
import { colorRgba,parseTime } from '@/utils/index'
import initData from "@/mixins/initData";
import { deleteMessagePushRule } from '@/api/sys/messagePushRule'
export default {
  name: "index",
  components: {
    addPushRuleDialog,
    editPushRuleDialog,
    queryHeader,
    multipleDeleteDialog,
  },
  data() {
    return {
      author: '',
      category: '',
      selected: [],
      red: '#D85E5F',
      green: '#41B883',
      addDialogShow: false,
      editDialogShow: false,
      currentRow: {},
      ids:[],
      strategyOptions: [],
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  mounted(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/wx/manage/spiderArticlePublish/list';
      this.params = {
        page: this.page,
        limit: this.size,
        sidx: 'id',
        order:'desc'
      }
      let header = this.$refs.header;
      if(header.celv){
        this.params.strategyId = header.celv;
      }
      if(header.pushChannel){
        this.params.channelType = header.pushChannel;
      }
      if(header.pushConfig){
        this.params.senderId = header.pushConfig;
      }
      if(header.ruleName){
        this.params.ruleName = header.ruleName;
      }
      if(header.status !== ''){
        this.params.status = header.status;
      }
      if(header.pickerTime && header.pickerTime.length){
        this.params.startTime = header.pickerTime[0];
        this.params.endTime = header.pickerTime[1];
      }
      return true;
    },
    getSource(tr){
      switch (tr.strategySourceType){
        case 1:
          return '微信公众号';
        case 2:
          return '个人微信';
        case 5:
          return 'Telegram Bot';
        case 6:
          return 'Lark应用';
        default:
          return 'Webhook';
      }
    },
    setStrategyOptions(options){
      this.strategyOptions = options;
    },
    findStrategy(tr){
      return this.strategyOptions.find(item => String(item.id) === String(tr.strategyId));
    },
    getStrategySourceName(tr){
      if(tr.strategySourceName) return tr.strategySourceName;
      const strategy = this.findStrategy(tr);
      return [5, 6].includes(Number(tr.strategySourceType)) && strategy
        ? (strategy.sourceOfficialName || strategy.sourceId || '-')
        : '-';
    },
    getStrategyAuthorName(tr){
      if(tr.strategyAuthorName) return tr.strategyAuthorName;
      const strategy = this.findStrategy(tr);
      return [5, 6].includes(Number(tr.strategySourceType)) && strategy
        ? (strategy.authorNickName || strategy.authorId || '-')
        : '-';
    },
    getType(tr){
      if(tr.status){
        return {
          backgroundColor: colorRgba(this.green,.1),
          color: this.green,
        }
      }else {
        return {
          backgroundColor: colorRgba(this.red,.1),
          color: this.red,
        }
      }
    },
    getChannel(tr){
      switch (tr.channelType){
        case 1:
          return '微信公众号';
        case 2:
          return 'Telegram';
        case 3:
          return 'Lark应用';
        case 4:
          return '企业微信';
        case 5:
          return '微信机器人';
        case 6:
          return '飞书机器人';
        case 7:
          return '钉钉机器人';
        case 8:
          return 'MT4';
        case 9:
          return 'Line';
        case 10:
          return 'QQ';
      }
    },
    addHandle(){
      setTimeout(() => {
        this.addDialogShow = true;
      },200);
    },
    addUserSuccess(){
      this.addDialogShow = false;
      this.searchHandle();
    },
    editHandle(row){
      this.currentRow = row;
      setTimeout(() => {
        this.editDialogShow = true;
      },200);
    },
    editUserSuccess(){
      this.editDialogShow = false;
      this.searchHandle();
    },
    closeEditDialog(){
      //需要重置currentRow
      this.currentRow = {};
      this.editDialogShow = false;
    },
    deleteHandle(id){
      this.ids = id ? [id] : this.selected.map(item => item.id);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids){
      deleteMessagePushRule(ids).then((res) => {
        this.$message({
          type: 'success',
          message: '删除成功'
        });
        this.$refs.muldelete.dialogShow = false;
        this.searchHandle();
      })
    },
    closeAddDialog(){
      this.addDialogShow = false;
    },
    getStatus(tr){
      if(tr.status === 0){
        return '禁用';
      }else {
        return '正常';
      }
    },
    getStyle(tr){
      if(tr.status === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.project-user-list {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {

  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
}
</style>
